module.exports = __webpack_public_path__ + "static/img/icon3.db75f952.png";